var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAgreementServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 254,
    viewBox: "0 0 238 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_1301)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_1301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.5254,
    y: 44.5449,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 99.8721,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 111.45,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 123.029,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 134.607,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9988 73.0177V74.0449C53.9988 75.4066 53.9988 76.9355 53.5568 79.2408L52.0279 79.0855C52.44 77.0311 52.4579 75.5022 52.4699 74.2241H46.0676V73.0177H53.9988ZM54.9543 80.3755V81.6178H45.0404V80.3755H48.5879V76.6369H50.1048V80.3755H54.9543ZM65.5611 80.4233V81.6417H55.6113V80.4233H59.768V77.9628H61.2849V80.4233H65.5611ZM61.3327 73.4716C61.3327 75.0244 62.7302 76.6608 65.2147 77.043L64.5697 78.3091C62.6585 77.9628 61.2371 76.9415 60.5205 75.5858C59.8038 76.9355 58.3943 77.9687 56.4952 78.3091L55.8502 77.043C58.3107 76.6608 59.6963 75.0125 59.7082 73.4716V72.6952H61.3327V73.4716ZM72.3575 72.8027V74.0211H70.1955C70.2075 75.2872 70.966 76.5115 72.7039 77.0191L71.9753 78.2136C70.7748 77.8493 69.9447 77.1207 69.4669 76.183C68.9832 77.2819 68.0993 78.1539 66.7913 78.5839L66.015 77.3775C67.8186 76.8101 68.6308 75.4007 68.6547 74.0211H66.433V72.8027H72.3575ZM74.8061 72.0741V74.5944H76.2753V75.8366H74.8061V78.5241H73.2772V72.0741H74.8061ZM71.2467 78.7391C73.5042 78.7272 74.9136 79.5036 74.9136 80.8294C74.9136 82.1553 73.5042 82.9436 71.2467 82.9436C68.9414 82.9436 67.52 82.1553 67.52 80.8294C67.52 79.5036 68.9414 78.7272 71.2467 78.7391ZM71.2467 79.9217C69.8133 79.9217 69.0369 80.2203 69.0489 80.8294C69.0369 81.4506 69.8133 81.7611 71.2467 81.7611C72.6561 81.7611 73.4086 81.4506 73.4086 80.8294C73.4086 80.2203 72.6561 79.9217 71.2467 79.9217Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_1301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 23.9941,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 79.3213,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 90.8994,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 102.479,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 114.057,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8889 51.5233V54.1392H81.3581V55.4053H79.8889V57.8898H78.36V51.5233H79.8889ZM74.2869 58.3078V59.132H78.36V58.3078H79.8889V62.2734H72.77V58.3078H74.2869ZM74.2869 61.0789H78.36V60.3025H74.2869V61.0789ZM77.715 52.4789V53.6733H71.265V52.4789H73.7375V51.4517H75.2544V52.4789H77.715ZM74.49 53.9839C76.0667 53.9839 77.1656 54.7483 77.1656 55.907C77.1656 57.0656 76.0667 57.83 74.49 57.83C72.8894 57.83 71.7905 57.0656 71.7905 55.907C71.7905 54.7483 72.8894 53.9839 74.49 53.9839ZM74.49 55.1067C73.7614 55.0947 73.2716 55.3933 73.2836 55.907C73.2716 56.4325 73.7614 56.7192 74.49 56.7192C75.2186 56.7192 75.7203 56.4325 75.7203 55.907C75.7203 55.3933 75.2186 55.0947 74.49 55.1067ZM85.3595 52.2519C87.0795 52.24 88.3695 53.3628 88.3695 54.9156C88.3695 56.4803 87.0795 57.5911 85.3595 57.5911C83.6395 57.5911 82.3375 56.4803 82.3375 54.9156C82.3375 53.3628 83.6395 52.24 85.3595 52.2519ZM85.3595 53.5658C84.4995 53.5658 83.8426 54.0675 83.8545 54.9156C83.8426 55.7756 84.4995 56.2653 85.3595 56.2653C86.2195 56.2653 86.8765 55.7756 86.8884 54.9156C86.8765 54.0675 86.2315 53.5658 85.3595 53.5658ZM90.9734 51.5233V62.4167H89.4565V51.5233H90.9734ZM81.8837 58.9528C83.8187 58.9648 86.5062 58.9289 88.8354 58.6064L88.9548 59.7053C86.542 60.1712 83.962 60.195 82.0628 60.195L81.8837 58.9528ZM96.5157 53.9839C96.5157 56.0264 97.3399 58.0092 99.1554 58.7975L98.2238 60.0159C97.0174 59.4246 96.2111 58.3436 95.7632 57.0059C95.2854 58.4273 94.4493 59.5918 93.2071 60.207L92.2515 58.9648C94.1149 58.1286 94.9629 56.0264 94.9749 53.9839V52.3594H96.5157V53.9839ZM101.58 51.5233V62.4167H100.075V56.1697H97.9371V54.9395H100.075V51.5233H101.58Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_1301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.43,
    y: 78.4854,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    transform: "rotate(18.5895 146.43 78.4854)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 144.34,
    y: 136.156,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 144.34 136.156)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.648,
    y: 147.131,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 140.648 147.131)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.958,
    y: 158.105,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 136.958 158.105)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.267,
    y: 169.079,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 133.267 169.079)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.697 117.375L174.863 119.854L176.256 120.323L175.852 121.523L174.46 121.055L173.668 123.409L172.218 122.922L174.248 116.888L175.697 117.375ZM168.225 122.02L167.962 122.801L171.822 124.099L172.085 123.318L173.534 123.806L172.27 127.564L165.523 125.295L166.787 121.536L168.225 122.02ZM167.341 124.646L171.202 125.945L171.449 125.209L167.589 123.91L167.341 124.646ZM173.332 117.588L172.951 118.72L166.838 116.664L167.218 115.532L169.562 116.32L169.889 115.346L171.327 115.83L171 116.803L173.332 117.588ZM169.795 117.986C171.29 118.489 172.088 119.564 171.718 120.662C171.349 121.76 170.064 122.134 168.569 121.632C167.052 121.121 166.254 120.047 166.624 118.948C166.993 117.85 168.278 117.476 169.795 117.986ZM169.438 119.05C168.751 118.807 168.191 118.934 168.039 119.424C167.86 119.919 168.233 120.347 168.924 120.579C169.614 120.811 170.181 120.699 170.349 120.201C170.512 119.714 170.132 119.271 169.438 119.05ZM180.65 119.81C182.284 120.347 183.149 121.822 182.654 123.294C182.155 124.777 180.578 125.419 178.948 124.87C177.318 124.322 176.438 122.854 176.937 121.371C177.432 119.899 179.024 119.25 180.65 119.81ZM180.231 121.055C179.416 120.781 178.633 121.047 178.374 121.855C178.089 122.666 178.555 123.339 179.371 123.614C180.186 123.888 180.965 123.633 181.25 122.822C181.509 122.014 181.058 121.333 180.231 121.055ZM186.203 120.909L182.731 131.234L181.293 130.75L184.766 120.425L186.203 120.909ZM175.219 125.053C177.05 125.681 179.608 126.504 181.919 126.941L181.682 128.02C179.246 127.693 176.793 126.893 174.993 126.287L175.219 125.053ZM190.672 125.008C190.021 126.944 190.17 129.086 191.64 130.412L190.368 131.269C189.413 130.324 188.994 129.043 188.995 127.632C188.089 128.827 186.926 129.664 185.552 129.851L185.042 128.369C187.075 128.171 188.549 126.449 189.212 124.516L189.729 122.977L191.19 123.468L190.672 125.008ZM196.257 124.29L192.784 134.615L191.358 134.135L193.349 128.214L191.322 127.533L191.715 126.367L193.741 127.048L194.83 123.81L196.257 124.29Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3447,
    y: 212.218,
    width: 8.01823,
    height: 50.6459,
    transform: "rotate(-35 66.3447 212.218)",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9635 203.258L72.9136 207.605L66.3295 212.216L64.9635 203.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.317 184.306L128.255 183.173L135.407 233.312L127.47 234.444L120.317 184.306Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.136 175.691L128.262 183.163L120.304 184.299L123.136 175.691Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_1301",
    x: 13.5254,
    y: 44.5449,
    width: 101.696,
    height: 132.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_1301",
    x: 39.75,
    y: 23.9941,
    width: 101.696,
    height: 132.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_1301",
    x: 107.627,
    y: 79.4873,
    width: 134.583,
    height: 153.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_1301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 254,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgreementServiceBody);
export default __webpack_public_path__ + "static/media/IcAgreementServiceBody.768378d8b56c4e5c396f4584dcf0278a.svg";
export { ForwardRef as ReactComponent };